import React, { Component, Fragment } from 'react';
import { getHumanReadableDateTime, getRequest, postRequest } from '../../globalhelper/helper';
import Select from 'react-select';
import DataTable from '../../components/DataTable2';


class SeqOfEvents extends Component {
    constructor(props) {
        super(props);
        this.state = { 
            formData: {
                device_id : '',
                // period_from : '',
                // period_to : ''
            },
            DeviceIDList : [],
            data : [],
            columns : [
                {
                    name: 'Device ID',
                    selector: row => row['Device ID'],
                    sortable: true,
                    width : '120px'
                },
                {
                    name: 'Event Category',
                    selector: row => row['Event Category'],
                    sortable: true,
                    width : '100px'
                },
                {
                    name: 'Event Codes',
                    selector: row => row['Event Codes'],
                    sortable: true,
                    wrap: true,
                },
                {
                    name: 'Start Date',
                    selector: row => getHumanReadableDateTime(row['Start Date']),
                    sortable: true,
                    wrap: true,
                    width : '150px'
                },
                {
                    name: 'End Date',
                    selector: row => getHumanReadableDateTime(row['End Date']),
                    sortable: true,
                    wrap: true,
                    width : '150px'
                },
                {
                    name: 'Days',
                    selector: row => row['Total Days'],
                    sortable: true,
                    width : '70px'
                },
                {
                    name: 'Hours',
                    selector: row => row['Total Hours'],
                    sortable: true,
                    width : '70px'
                },
                {
                    name: 'Minutes',
                    selector: row => row['Total Minutes'],
                    sortable: true,
                    width : '70px'
                },
            ],
            showData : false,
            fetching : false,
         }
    }

    handleChange = (ev) => {
        const { formData } = this.state;
        formData[ev.target.name] = ev.target.value;
        if(ev.target.name === 'device_obj'){
            formData['device_id'] = ev.target.value.value;
        }
        this.setState({ formData });
    }

    onDeviceIDChange = (device_id) => {
        console.log(device_id);
    }

    componentDidMount = () => {
        getRequest('api/cms/getEventCaptureDeviceList').then((res) => {
            if (res.type === "success") {
                this.setState({ DeviceIDList : JSON.parse(res.res.data) });
            }
        })

    }

    
  setDate = (date,field) =>{
  
      this.setState({
        ...this.state,
        formData : {
          ...this.state.formData,
          [field] : date,
        }
      })
    }

    onFetchData = () => {
        this.setState({
            ...this.state,
            fetching : true,
            showData : false,
            data : []
        }, () => {
        postRequest('api/cms/getSeqOfEventsForDeviceAndPeriod',this.state.formData).then(res => {
            if(res.type === "success")
            {
                this.setState({
                    ...this.state,
                    data : JSON.parse(res.res.data),
                    showData : true,
                    fetching : false,
                })
            }
        })
        })
    }

    render() { 
        return (  
            <div>
                <form name="event_history_form" defaultValue={this.state.formData}>
                    <div className="row">
                        <div className="col-md-2">
                            <label htmlFor="device_obj">Device ID</label>
                            <Select
                                value={this.state.formData.device_obj}
                                onChange={(value) => this.handleChange({ target : { name : 'device_obj', value } })}
                                options={this.state.DeviceIDList}
                            />
                        </div>
                        {/* <div className="col-md-2">
                            <label htmlFor="period_from">Period From</label>
                            <DatePicker selected={this.state.formData.period_from} showPopperArrow={false} dateFormat="dd/MM/yyyy" className="col-md-12" onChange={ (date) => this.setDate(date,'period_from') } id="period_from" />
                        </div>
                        <div className="col-md-2">
                            <label htmlFor="period_to">Period To</label>
                            <DatePicker selected={this.state.formData.period_to} showPopperArrow={false} dateFormat="dd/MM/yyyy" className="col-md-12" onChange={ (date) => this.setDate(date,'period_to') } id="period_to" />
                        </div> */}
                        <div className="col-md-2">
                            <button type='button' className='btn btn-info' disabled={ this.state.formData.device_id === "" || this.state.fetching } style={{ marginTop : 33 }} onClick={this.onFetchData} >Fetch Data</button>
                        </div>
                    </div>
                </form>
                <br /><br />
                <Fragment>
                    <DataTable title="Sequence of Events" loading={this.state.fetching} columns={this.state.columns} key={this.state.data} data={this.state.data} />
                </Fragment>
            </div>
        );
    }
}
 
export default SeqOfEvents;